export default "__VITE_ASSET__BivERQvG__"